import React from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DonateView from "./DonateView";

export function DonateContainer() {
  const mediaQueryMd = useMediaQuery("(max-width:960px)");
  const mediaQueryXs = useMediaQuery("(max-width:370px)");
  return <DonateView isMd={mediaQueryMd} isXs={mediaQueryXs} />;
}
